import React, { useContext } from 'react';
import { string } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Route, ScrollToTop, Switch } from '@thd-olt-component-react/router';
import { Error } from './pages';
import { getRoutes } from './routes';

export const App = ({ pipTimeout }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path={routes.browse.path}>
          {channel === 'mobile' ? <routes.browseMobile.component pageType="browse" />
            : <routes.browse.component pageType="browse" />}
        </Route>
        <Route path={routes.search.path}>
          {channel === 'mobile' ? <routes.searchMobile.component pageType="search" />
            : <routes.search.component pageType="search" />}
        </Route>
        <Route
          exact
          path={routes.pep.path}
        >
          {channel !== 'mobile' && <routes.pep.component />}
          {channel === 'mobile' && <routes.pepMobile.component />}
        </Route>
        <Route exact path={routes.product.path}>
          {channel === 'mobile' ? <routes.productMobile.component pipTimeout={pipTimeout} />
            : <routes.product.component pipTimeout={pipTimeout} />}
        </Route>
        <Route path={routes.collections.path}>
          {channel === 'mobile'
            ? <routes.collectionsMobile.component />
            : <routes.collections.component />}
        </Route>
        <Route path={routes.styleQuiz.path}>
          <routes.styleQuiz.component />
        </Route>
        <Route
          exact
          path={routes.home.path}
        >
          <routes.home.component />
        </Route>
        <Route path="/error">
          <Error />
        </Route>
        <Route>
          <Error />
        </Route>
      </Switch>
    </>
  );
};

App.propTypes = {
  pipTimeout: string
};

App.defaultProps = {
  pipTimeout: null
};
